import Alert from "components/common/Alert";
import { validateOrganizer } from "utils/companyValidation";
import { useState, useEffect, useRef } from "react";
import { getImageUrl } from "utils/imageHelper";
import { Country, State, City } from "country-state-city";
// import ImageViewer from "components/common/ImageViewer";
import React from "react";
import {
  InputField,
  SelectField,
  ImageUploadField,
  ColorPickerField,
  TextareaField,
  RichTextEditor,
  InputWithButtonField,
  PhoneNumberField,
} from ".././FormFields";
import PageLayout from ".././PageFromLayout";
// import { currencyOptions } from "../../utils/countryData";
import { getCurrencyDropdown } from "../../api/currency.api";
//  const res = await getCurrencies();
import FormSection from ".././FormSection";
import { validateImageFile } from "utils/common";

export default function OrganizerForm({
  onSubmit,
  initialData = null,
  submitLabel = "Create Organizer",
  alert,
  setAlert,
  onBack,
  organizerRoute = [],
}) {
  const [existingLogo, setExistingLogo] = useState(null);
  const [existingBanner, setExistingBanner] = useState(null);
  const [existingBlcakLogo, setexistingBlcakLogo] = useState(null);
  const [existingHospitalityImage, setExistingHospitalityImage] =
    useState(null);
  const [errors, setErrors] = useState({});
  const [emailInput, setEmailInput] = useState("");
  const [highlights, setHighlights] = useState("");
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [loader, setLoader] = useState(false);
  // const [showPassword, setShowPassword] = useState(false);
  // const [viewerOpen, setViewerOpen] = useState(false);

  const alertRef = useRef(null);
  const eventTypeList = [
    {
      value: "expo",
      label: "Expo",
    },
    { value: "summit", label: "summit" },
  ];
  const emailProviderOptions = [
    { value: "google", label: "Google (Gmail / Workspace)" },
    { value: "microsoft", label: "Microsoft (Outlook / Office 365)" },
  ];
  const [formData, setFormData] = useState({
    companyName: "",
    subTitle: "",
    agendaSubtitle: "",
    speakersSubtitle: "",
    registerLink: "",
    companyEmail: "",
    companyLogo: null,
    companyLogoBlack: null,
    eventBanner: "",
    companyMobileCountryCode: "+40",
    companyMobile: "",
    companyPhoneNumber: "",
    companyAddress: "",
    companyCountry: "RO",
    companyState: "",
    companyDistrict: "",
    companyCity: "",
    companyPincode: "",
    companyGST: "",
    companyWebsite: "",

    adminName: "",
    adminEmail: "",
    adminPassword: "",
    adminMobileCountryCode: "+40",
    adminMobile: "",

    // Email Configuration Fields
    emailProvider: "",
    emailUsername: "",
    emailAppPassword: "",

    communicationEmails: [],
    projectModules: [],
    eventHighlights: [],
    primaryColor: "#465fff",
    secondaryColor: "#111827",
    // isBulk: false,

    // Newly Added Schema Fields
    price: "0",
    currency: "INR",
    ticketStartDate: "",
    ticketEndDate: "",
    eventStartDate: "",
    eventEndDate: "",
    eventType: "",
    tax: "0",

    aboutEvent: "",
    staffDetails: [],
    ticketDiscounts: [],
    ticketPriceTiers: [],
    facebookLink: "",
    instaLink: "",
    linkedinLink: "",
    youtubeLink: "",
    playStoreLink: "",
    appStoreLink: "",
    termsAndConditions: "",
    privacyPolicy: "",
    sponsorImages: [],
    eventTimings: [],
    notify: false,

    eventFeatures: [],
    whyParticipate: {
      title: "WHY PARTICIPATE IN HORECA SUMMIT",
      description: "",
      columns: [],
      bottomBannerText: "",
      bottomButtonText: "GET YOUR TICKET",
    },
    hospitalitySection: {
      title: "HOSPITALITY IS CHANGING BEFORE OUR EYES...",
      image: null,
      points: [],
      pointInput: "",
    },
  });
  const formatDateTimeForInput = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "";

    // Extract UTC components directly to match the DB string exactly
    const pad = (num) => String(num).padStart(2, "0");

    const year = date.getUTCFullYear();
    const month = pad(date.getUTCMonth() + 1);
    const day = pad(date.getUTCDate());
    const hours = pad(date.getUTCHours());
    const minutes = pad(date.getUTCMinutes());

    // Returns "YYYY-MM-DDTHH:mm" for <input type="datetime-local" />
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };
  useEffect(() => {
    const fetchCurrencies = async () => {
      try {
        const res = await getCurrencyDropdown();
        if (res?.success && Array.isArray(res.data)) {
          const formattedOptions = res.data.map((item) => ({
            value: item._id,
            label: `${item.code} (${item.symbol})`, // Creates format like "USD ($)"
          }));

          setCurrencyOptions(formattedOptions);
        }
      } catch (error) {
        console.error("Error fetching currencies:", error);
      }
    };

    fetchCurrencies();
  }, []);
  useEffect(() => {
    if (!initialData) return;

    let emails = initialData.communicationEmails || [];

    if (
      emails.length === 1 &&
      typeof emails[0] === "string" &&
      emails[0].includes(",")
    ) {
      emails = emails[0].split(",").map((e) => e.trim());
    }

    setFormData((prev) => ({
      ...prev,
      ...initialData,
      companyLogo: null,
      communicationEmails: emails,
      projectModules: initialData.projectModules || [],
      // isBulk: Boolean(initialData.isBulk),
      price: initialData.price ?? initialData.prize ?? "0",
      currency: initialData.currency,
      ticketStartDate: formatDateTimeForInput(initialData.ticketStartDate),
      ticketEndDate: formatDateTimeForInput(initialData.ticketEndDate),
      eventStartDate: formatDateTimeForInput(initialData.eventStartDate),
      eventEndDate: formatDateTimeForInput(initialData.eventEndDate),
      ticketPriceTiers: (initialData.ticketPriceTiers || []).map((t) => ({
        ...t,
        startDate: formatDateTimeForInput(t.startDate),
        endDate: formatDateTimeForInput(t.endDate),
      })),
      staffDetails: initialData.staffDetails?.length
        ? initialData.staffDetails
        : prev.staffDetails,
      emailProvider: initialData.emailProvider || "",
      emailUsername: initialData.emailUsername || "",
      emailAppPassword: initialData.emailAppPassword || "",
      eventFeatures: initialData.eventFeatures || [],
      whyParticipate: initialData.whyParticipate || {},
      hospitalitySection: {
        ...prev.hospitalitySection,
        ...(initialData.hospitalitySection || {}),
        pointInput: "",
      },
    }));

    if (initialData.companyLogo) {
      setExistingLogo(initialData.companyLogo);
    }
    if (initialData.eventBanner) {
      setExistingBanner(initialData.eventBanner);
    }
    if (initialData.companyLogoBlack) {
      setexistingBlcakLogo(initialData.companyLogoBlack);
    }
    if (initialData.hospitalitySection?.image) {
      setExistingHospitalityImage(initialData.hospitalitySection.image);
    }
  }, [initialData]);

  useEffect(() => {
    if (alert && alertRef.current) {
      alertRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [alert]);

  const countryOptions = Country.getAllCountries();
  const stateOptions = formData.companyCountry
    ? State.getStatesOfCountry(formData.companyCountry)
    : [];
  const districtOptions =
    formData.companyCountry && formData.companyState
      ? City.getCitiesOfState(formData.companyCountry, formData.companyState)
      : [];

  const countryCodeOptions = countryOptions.map((c) => ({
    value: `+${c.phonecode}`,
    label: `+${c.phonecode}`,
  }));

  const countrySelectOptions = countryOptions.map((c) => ({
    value: c.isoCode,
    label: c.name,
  }));

  const stateSelectOptions = stateOptions.map((s) => ({
    value: s.isoCode,
    label: s.name,
  }));

  const districtSelectOptions = districtOptions.map((d) => ({
    value: d.name,
    label: d.name,
  }));

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const val = type === "checkbox" ? checked : value;

    setFormData((prev) => {
      const updated = { ...prev, [name]: val };

      if (name === "eventStartDate" || name === "eventEndDate") {
        updated.eventTimings = generateEventTimings(
          updated.eventStartDate,
          updated.eventEndDate,
          prev.eventTimings
        );
      }

      return updated;
    });

    setErrors((p) => ({ ...p, [name]: "" }));
  };

  const handleTimingChange = (index, field, value) => {
    setFormData((prev) => {
      const updatedTimings = [...prev.eventTimings];
      updatedTimings[index] = { ...updatedTimings[index], [field]: value };
      return { ...prev, eventTimings: updatedTimings };
    });
  };

  const handleStaffChange = (index, field, value) => {
    setFormData((prev) => {
      const updated = [...prev.staffDetails];
      updated[index] = { ...updated[index], [field]: value };
      return { ...prev, staffDetails: updated };
    });

    setErrors((p) => ({ ...p, [`staff_${field}_${index}`]: "" }));
  };

  // DYNAMIC STAFF HANDLERS
  const addStaff = () => {
    setFormData((prev) => ({
      ...prev,
      staffDetails: [
        ...prev.staffDetails,
        {
          email: "",
          password: "",
          permissions: structuredClone(organizerRoute),
        },
      ],
    }));
  };

  const removeStaff = (index) => {
    setFormData((prev) => ({
      ...prev,
      staffDetails: prev.staffDetails.filter((_, i) => i !== index),
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    const name = e.target.name;
    let maxMp = 3;
    if (name === "eventBanner") {
      maxMp = 5;
    }
    if (!file) return;

    const { isValid, error } = validateImageFile(file, maxMp);

    if (!isValid) {
      setErrors((prev) => ({ ...prev, [name]: error }));
      return;
    }
    // const allowedTypes = ["image/jpeg", "image/png"];
    // if (!allowedTypes.includes(file.type)) {
    //   setErrors((p) => ({
    //     ...p,
    //     [name]: "Only JPEG and PNG files are allowed",
    //   }));
    //   return;
    // }

    const img = new Image();
    img.src = URL.createObjectURL(file);

    img.onload = () => {
      let REQUIRED_WIDTH = 120;
      let REQUIRED_HEIGHT = 40;
      if (name === "eventBanner") {
        REQUIRED_WIDTH = 393;
        REQUIRED_HEIGHT = 219;
      }

      // if (img.width !== REQUIRED_WIDTH || img.height !== REQUIRED_HEIGHT) {
      //   console.log("Error")
      //   setErrors((p) => ({
      //     ...p,
      //     name: `Logo must be exactly ${REQUIRED_WIDTH} × ${REQUIRED_HEIGHT} px`,
      //   }));
      //   return;
      // }

      setFormData((p) => ({ ...p, [name]: file }));
      if (name === "eventBanner") {
        setExistingBanner(null);
      } else if (name === "companyLogoBlack") {
        setexistingBlcakLogo(null);
      } else {
        setExistingLogo(null);
      }
      setErrors((p) => ({ ...p, name: "" }));
    };
  };

  const handleModuleChange = (module) => {
    setFormData((p) => ({
      ...p,
      projectModules: p.projectModules.includes(module)
        ? p.projectModules.filter((m) => m !== module)
        : [...p.projectModules, module],
    }));
  };

  const addEventHighlights = () => {
    const highlight = highlights.trim();
    if (formData.eventHighlights.includes(highlight)) {
      setErrors((p) => ({
        ...p,
        eventHighlights: "Email already added",
      }));
      return;
    }

    setFormData((p) => ({
      ...p,
      eventHighlights: [...p.eventHighlights, highlight],
    }));

    setHighlights("");
    setErrors((p) => ({ ...p, eventHighlights: "" }));
  };

  const updateHighlight = (index, value) => {
    setFormData((p) => ({
      ...p,
      eventHighlights: p.eventHighlights.map((e, i) =>
        i === index ? value : e
      ),
    }));
  };

  const removeHighlight = (index) => {
    setFormData((p) => ({
      ...p,
      eventHighlights: p.eventHighlights.filter((_, i) => i !== index),
    }));
  };

  const addEmail = () => {
    const email = emailInput.trim();
    if (!email) return;

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setErrors((p) => ({
        ...p,
        communicationEmails: "Invalid email format",
      }));
      return;
    }

    if (formData.communicationEmails.includes(email)) {
      setErrors((p) => ({
        ...p,
        communicationEmails: "Email already added",
      }));
      return;
    }

    setFormData((p) => ({
      ...p,
      communicationEmails: [...p.communicationEmails, email],
    }));

    setEmailInput("");
    setErrors((p) => ({ ...p, communicationEmails: "" }));
  };

  const removeEmail = (index) => {
    setFormData((p) => ({
      ...p,
      communicationEmails: p.communicationEmails.filter((_, i) => i !== index),
    }));
  };

  const updateEmail = (index, value) => {
    setFormData((p) => ({
      ...p,
      communicationEmails: p.communicationEmails.map((e, i) =>
        i === index ? value : e
      ),
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // Moved to the very top

    try {
      const validationErrors = validateOrganizer(
        formData,
        Boolean(initialData)
      );

      if (Object.keys(validationErrors).length > 0) {
        setErrors(validationErrors);
        setAlert("Please fix the highlighted errors");
        return;
      }

      setErrors({});
      setAlert("");
      setLoader(true);

      await onSubmit(formData);
    } catch (error) {
      console.error("Submission failed:", error);
      setAlert(error?.message || "An unexpected error occurred.");
    } finally {
      setLoader(false); // Guarantees loader resets even if onSubmit throws
    }
  };

  const handleColorChange = (name, value) => {
    setFormData((p) => ({ ...p, [name]: value }));
    setErrors((p) => ({ ...p, [name]: "" }));
  };

  const handlePermissionChange = (staffIndex, permissionIndex, field) => {
    setFormData((prev) => {
      const updated = [...prev.staffDetails];

      updated[staffIndex] = {
        ...updated[staffIndex],
        permissions: updated[staffIndex].permissions.map((permission, index) =>
          index === permissionIndex
            ? {
                ...permission,
                [field]: !permission[field],
              }
            : permission
        ),
      };

      return {
        ...prev,
        staffDetails: updated,
      };
    });
  };
  const handleDiscountChange = (index, field, value) => {
    const updatedTiers = [...formData.ticketDiscounts];
    updatedTiers[index][field] = value === "" ? "" : Number(value);
    setFormData((prev) => ({ ...prev, ticketDiscounts: updatedTiers }));
  };

  const addDiscountTier = () => {
    setFormData((prev) => ({
      ...prev,
      ticketDiscounts: [
        ...prev.ticketDiscounts,
        { minQty: "", maxQty: "", discountPercentage: "" },
      ],
    }));
  };

  const removeDiscountTier = (index) => {
    setFormData((prev) => ({
      ...prev,
      ticketDiscounts: prev.ticketDiscounts.filter((_, i) => i !== index),
    }));
  };
  // Date-Based Ticket Pricing Tiers Handlers
  const handlePriceTierChange = (index, field, value) => {
    const updated = [...formData.ticketPriceTiers];
    updated[index][field] = value;
    setFormData((prev) => ({ ...prev, ticketPriceTiers: updated }));
  };

  const addPriceTier = () => {
    setFormData((prev) => ({
      ...prev,
      ticketPriceTiers: [
        ...prev.ticketPriceTiers,
        { title: "", price: "", startDate: "", endDate: "" },
      ],
    }));
  };

  const removePriceTier = (index) => {
    setFormData((prev) => ({
      ...prev,
      ticketPriceTiers: prev.ticketPriceTiers.filter((_, i) => i !== index),
    }));
  };

  const isTicketDatesEnabled = Boolean(
    formData.eventStartDate && formData.eventEndDate
  );
  const pageTitle = initialData ? "Edit Master Event" : "Create Master Event";
  const pageSubTitle = initialData
    ? "Update the master event details below."
    : "Add a new master event to the platform. Fill in the details below.";

  const handleSponsorImagesChange = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;

    // 1. Validate all files using validateImageFile (passing 3 for 3 MB limit)
    const validationResults = await Promise.all(
      files.map((file) => validateImageFile(file, 3))
    );

    // 2. Find the first invalid file's error message (if any)
    const invalidResult = validationResults.find((res) => !res.isValid);

    if (invalidResult) {
      setErrors((p) => ({
        ...p,
        sponsorImages: invalidResult.error,
      }));
      return; // Block state update if any file fails validation
    }

    // 3. Append validated files to formData
    setFormData((prev) => ({
      ...prev,
      sponsorImages: [...(prev.sponsorImages || []), ...files], // Fixed: changed validFiles to files
    }));

    // 4. Clear previous error message
    setErrors((p) => ({ ...p, sponsorImages: "" }));
  };

  const removeSponsorImage = (index) => {
    setFormData((prev) => ({
      ...prev,
      sponsorImages: prev.sponsorImages.filter((_, i) => i !== index),
    }));
  };

  const generateEventTimings = (
    startDateStr,
    endDateStr,
    currentTimings = []
  ) => {
    if (!startDateStr || !endDateStr) return [];

    // Extract only "YYYY-MM-DD" from any input (ISO string, Date object, or custom string)
    const extractDateString = (input) => {
      if (!input) return "";
      if (typeof input === "string") {
        return input.split("T")[0];
      }
      const d = new Date(input);
      if (isNaN(d.getTime())) return "";
      return d.toISOString().split("T")[0];
    };

    const startDayStr = extractDateString(startDateStr);
    const endDayStr = extractDateString(endDateStr);

    if (!startDayStr || !endDayStr || startDayStr > endDayStr) {
      return [];
    }

    // Parse YYYY-MM-DD as UTC Midnight (00:00:00) so times do not interfere
    const [sYear, sMonth, sDay] = startDayStr.split("-").map(Number);
    const [eYear, eMonth, eDay] = endDayStr.split("-").map(Number);

    const startUtc = new Date(Date.UTC(sYear, sMonth - 1, sDay));
    const endUtc = new Date(Date.UTC(eYear, eMonth - 1, eDay));

    // Total inclusive days based purely on date difference
    const diffTime = endUtc.getTime() - startUtc.getTime();
    const totalDays = Math.round(diffTime / (1000 * 60 * 60 * 24)) + 1;

    const timings = [];
    const currDate = new Date(startUtc);

    for (let i = 0; i < totalDays; i++) {
      // Current day "YYYY-MM-DD"
      const formattedDateStr = currDate.toISOString().split("T")[0];

      // Find existing timings by comparing "YYYY-MM-DD" only
      const existing = currentTimings.find((t) => {
        if (!t || !t.date) return false;
        return extractDateString(t.date) === formattedDateStr;
      });

      timings.push({
        day: `Day - ${i + 1}`,
        date: `${formattedDateStr}T00:00:00.000Z`, // Clean UTC midnight date for DB
        startTime: existing?.startTime || "09:00",
        endTime: existing?.endTime || "18:00",
      });

      // Advance 1 calendar day
      currDate.setUTCDate(currDate.getUTCDate() + 1);
    }

    return timings;
  };
  // 2. Handlers for "Supporting Business Operators" (Event Features)
  const addEventFeature = () => {
    setFormData((prev) => ({
      ...prev,
      eventFeatures: [
        ...prev.eventFeatures,
        { logo: null, title: "", description: "" },
      ],
    }));
  };

  const removeEventFeature = (index) => {
    setFormData((prev) => ({
      ...prev,
      eventFeatures: prev.eventFeatures.filter((_, i) => i !== index),
    }));
  };

  const handleFeatureChange = (index, field, value) => {
    setFormData((prev) => {
      const updated = [...prev.eventFeatures];
      updated[index] = { ...updated[index], [field]: value };
      return { ...prev, eventFeatures: updated };
    });
  };

  const handleFeatureLogoChange = async (index, file) => {
    const { isValid, error } = await validateImageFile(file, 2);

    if (!isValid) {
      // Set error message for the specific array item index
      setErrors((prev) => ({
        ...prev,
        [`eventFeatureLogo_${index}`]: error,
      }));
      return; // Stop execution if invalid
    }

    // 2. Clear error for this item if valid
    setErrors((prev) => ({
      ...prev,
      [`eventFeatureLogo_${index}`]: "",
    }));
    setFormData((prev) => {
      const updated = [...prev.eventFeatures];
      updated[index] = { ...updated[index], logo: file, hasNewLogo: true };
      return { ...prev, eventFeatures: updated };
    });
  };

  const addWhyColumn = () => {
    setFormData((prev) => ({
      ...prev,
      whyParticipate: {
        ...prev.whyParticipate,
        columns: [
          ...(prev.whyParticipate.columns || []),
          { title: "", points: [], footerText: "", pointInput: "" },
        ],
      },
    }));
  };

  const removeWhyColumn = (index) => {
    setFormData((prev) => ({
      ...prev,
      whyParticipate: {
        ...prev.whyParticipate,
        columns: prev.whyParticipate.columns.filter((_, i) => i !== index),
      },
    }));
  };

  const handleWhyColumnChange = (colIndex, field, value) => {
    setFormData((prev) => {
      const updatedCols = [...(prev.whyParticipate.columns || [])];
      updatedCols[colIndex] = { ...updatedCols[colIndex], [field]: value };
      return {
        ...prev,
        whyParticipate: { ...prev.whyParticipate, columns: updatedCols },
      };
    });
  };

  const addPointToWhyColumn = (colIndex) => {
    const col = formData.whyParticipate.columns[colIndex];
    const point = col.pointInput?.trim();
    if (!point) return;

    setFormData((prev) => {
      const updatedCols = [...prev.whyParticipate.columns];
      updatedCols[colIndex] = {
        ...updatedCols[colIndex],
        points: [...updatedCols[colIndex].points, point],
        pointInput: "",
      };
      return {
        ...prev,
        whyParticipate: { ...prev.whyParticipate, columns: updatedCols },
      };
    });
  };

  const removePointFromWhyColumn = (colIndex, pointIndex) => {
    setFormData((prev) => {
      const updatedCols = [...prev.whyParticipate.columns];
      updatedCols[colIndex] = {
        ...updatedCols[colIndex],
        points: updatedCols[colIndex].points.filter((_, i) => i !== pointIndex),
      };
      return {
        ...prev,
        whyParticipate: { ...prev.whyParticipate, columns: updatedCols },
      };
    });
  }; // --- HANDLERS FOR HOSPITALITY SECTION ---
  const addHospitalityPoint = () => {
    const pt = formData.hospitalitySection.pointInput?.trim();
    if (!pt) return;

    setFormData((prev) => ({
      ...prev,
      hospitalitySection: {
        ...prev.hospitalitySection,
        points: [...(prev.hospitalitySection.points || []), pt],
        pointInput: "",
      },
    }));
  };

  const removeHospitalityPoint = (index) => {
    setFormData((prev) => ({
      ...prev,
      hospitalitySection: {
        ...prev.hospitalitySection,
        points: prev.hospitalitySection.points.filter((_, i) => i !== index),
      },
    }));
  };
  return (
    <PageLayout
      onBack={onBack}
      onSubmit={handleSubmit}
      submitText={
        submitLabel || (initialData ? "Update Master Event" : "Create")
      }
      loading={loader}
    >
      <form onSubmit={handleSubmit} className="flex flex-col gap-6">
        {alert && (
          <div ref={alertRef} className="scroll-mt-[100px] px-6 pt-3">
            <Alert type="error" message={alert} onClose={() => setAlert("")} />
          </div>
        )}
        {/* ORGANIZER DETAILS */}
        <FormSection
          title="Event Details"
          // subtitle={`${initialData ? "Update" : "Add"} the main details about the scanner.`}
        >
          <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
            <InputField
              label="Title"
              name="companyName"
              value={formData.companyName}
              onChange={handleChange}
              placeholder="Enter Title"
              required
              error={errors.companyName}
            />
            <InputField
              label="Sub Title"
              name="subTitle"
              value={formData.subTitle}
              onChange={handleChange}
              placeholder="Enter sub title"
              required
              error={errors.subTitle}
            />
            <InputField
              label="Agenda Subtitle (mobile app)"
              name="agendaSubtitle"
              value={formData.agendaSubtitle || ""}
              onChange={handleChange}
              placeholder="e.g. A focused day of insights, conversations and connections."
            />
            <InputField
              label="Speakers Subtitle (mobile app)"
              name="speakersSubtitle"
              value={formData.speakersSubtitle || ""}
              onChange={handleChange}
              placeholder="e.g. The leaders shaping the next chapter of hospitality."
            />
            <InputField
              label="Register / Ticket Link (mobile app)"
              name="registerLink"
              value={formData.registerLink || ""}
              onChange={handleChange}
              placeholder="e.g. https://register.horecasummit.ro/visitor/<event id>"
            />
            <RichTextEditor
              label="About Event"
              value={formData.aboutEvent}
              onChange={(htmlContent) =>
                handleChange({
                  target: {
                    name: "aboutEvent",
                    value: htmlContent,
                  },
                })
              }
              required
              error={errors.aboutEvent}
              maxChars={500}
            />
            {/* <Section title="Event Highlights">
              <div className="col-span-2 flex gap-2">
                <InputField
                  name="highlights"
                  value={highlights}
                  onChange={(e) => setHighlights(e.target.value)}
                  placeholder="Enter highlights"
                />
                <button
                  type="button"
                  onClick={addEventHighlights}
                  className="btn-primary mb-1 shrink-0 self-end px-4 py-2"
                >
                  Add
                </button>
              </div>

              <div className="col-span-2">
                <div className="flex flex-wrap gap-2.5">
                  {formData.eventHighlights?.map((highlight, i) => (
                    <div
                      key={i}
                      className="focus-within:border-slate-400 focus-within:ring-slate-400 inline-flex items-center gap-2 rounded-lg border border-gray-200 bg-gray-50 px-3 py-1.5 transition-colors focus-within:bg-white focus-within:ring-1"
                    >
                      <input
                        type="text"
                        value={highlight}
                        onChange={(e) => updateHighlight(i, e.target.value)}
                        placeholder="Enter highlight..."
                        className="bg-transparent text-slate-800 min-w-[100px] max-w-[240px] shrink text-xs font-medium outline-none placeholder:text-gray-400"
                      />

                      <button
                        type="button"
                        onClick={() => removeHighlight(i)}
                        className="flex h-4 w-4 shrink-0 items-center justify-center rounded-full text-gray-400 transition-colors hover:bg-red-100 hover:text-red-600"
                        title="Remove highlight"
                      >
                        <span className="text-xs font-bold leading-none">
                          ×
                        </span>
                      </button>
                    </div>
                  ))}
                </div>
              </div>

              {errors.eventHighlights && (
                <p className="col-span-2 text-xs text-red-500">
                  {errors.eventHighlights}
                </p>
              )}
            </Section> */}
            <div>
              <InputWithButtonField
                label="Evetn Highlights"
                name="highlights"
                value={highlights}
                onChange={(e) => setHighlights(e.target.value)}
                placeholder="Enter highlights"
                onButtonClick={addEventHighlights}
                buttonText="Add"
              />
              <div className="mt-2 flex w-full flex-col gap-2.5">
                {formData.eventHighlights?.map((highlight, i) => (
                  <div
                    key={i}
                    className="focus-within:border-slate-400 focus-within:ring-slate-400 flex w-full items-center justify-between gap-2 rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 transition-colors focus-within:bg-white focus-within:ring-1"
                  >
                    <input
                      type="text"
                      value={highlight}
                      onChange={(e) => updateHighlight(i, e.target.value)}
                      placeholder="Enter highlight..."
                      className="bg-transparent text-slate-800 w-full text-xs font-medium outline-none placeholder:text-gray-400"
                    />

                    <button
                      type="button"
                      onClick={() => removeHighlight(i)}
                      className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full text-gray-400 transition-colors hover:bg-red-100 hover:text-red-600"
                      title="Remove highlight"
                    >
                      <span className="text-sm font-bold leading-none">×</span>
                    </button>
                  </div>
                ))}
              </div>
              {errors.eventHighlights && (
                <p className="text-xs text-red-500">{errors.eventHighlights}</p>
              )}
            </div>
            <ColorPickerField
              label="Primary Color"
              name="primaryColor"
              value={formData.primaryColor}
              onChange={(e) =>
                handleColorChange("primaryColor", e.target.value)
              }
              placeholder="#465FFF"
              required
              error={errors.primaryColor}
            />
            <ColorPickerField
              label="Secondary Color"
              name="secondaryColor"
              value={formData.secondaryColor}
              onChange={(e) =>
                handleColorChange("secondaryColor", e.target.value)
              }
              placeholder="#111827"
              required
              error={errors.secondaryColor}
            />

            <SelectField
              label="Event Type"
              name="eventType"
              value={formData.eventType}
              onChange={(e) =>
                setFormData((p) => ({
                  ...p,
                  eventType: e.target.value,
                }))
              }
              options={eventTypeList}
              placeholder="Search Type..."
              isSearchable={true}
              error={errors.eventType}
              required
            />
            <div>
              <label className="form-label">Notify</label>
              <button
                type="button"
                role="switch"
                aria-checked={formData.notify}
                onClick={() =>
                  setFormData((prev) => ({ ...prev, notify: !prev.notify }))
                }
                className={`border-transparent relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 transition-colors duration-200 ease-in-out focus:outline-none ${
                  formData.notify ? "bg-blue-600" : "bg-gray-300"
                }`}
              >
                <span
                  className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow-md ring-0 transition duration-200 ease-in-out ${
                    formData.notify ? "translate-x-5" : "translate-x-0"
                  }`}
                />
              </button>
            </div>
          </div>
        </FormSection>
        <FormSection
          title="Event Media"
          // subtitle={`${initialData ? "Update" : "Add"} the main details about the scanner.`}
        >
          <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
            <ImageUploadField
              label="Event Logo White (Recommended: 120x40)"
              name="companyLogo"
              // recommended={
              //   <>
              //     Recommended resolution: <b>120 × 40 px</b>. Accepted formats:
              //     JPEG, PNG.
              //   </>
              // }
              preview={
                existingLogo
                  ? getImageUrl(existingLogo)
                  : formData.companyLogo
                  ? URL.createObjectURL(formData.companyLogo)
                  : ""
              }
              onUpload={handleFileChange}
              required
              error={errors.companyLogo}
              accept="image/jpeg, image/png, image/webp, image/heic, image/heif, .heic, .heif"
            />
            <ImageUploadField
              label="Event Logo Blcak (Recommended: 120x40)"
              name="companyLogoBlack"
              // recommended={
              //   <>
              //     Recommended resolution: <b>120 × 40 px</b>. Accepted formats:
              //     JPEG, PNG.
              //   </>
              // }
              preview={
                existingBlcakLogo
                  ? getImageUrl(existingBlcakLogo)
                  : formData.companyLogoBlack
                  ? URL.createObjectURL(formData.companyLogoBlack)
                  : ""
              }
              onUpload={handleFileChange}
              required
              error={errors.companyLogoBlack}
              accept="image/jpeg, image/png, image/webp, image/heic, image/heif, .heic, .heif"
            />
            <ImageUploadField
              label="Event Banner (Recommended: 393x219)"
              name="eventBanner"
              // recommended={
              //   <>
              //     Recommended resolution: <b>393 × 219 px</b>. Accepted formats:
              //     JPEG, PNG.
              //   </>
              // }
              preview={
                existingBanner
                  ? getImageUrl(existingBanner)
                  : formData.eventBanner
                  ? URL.createObjectURL(formData.eventBanner)
                  : ""
              }
              onUpload={handleFileChange}
              required
              error={errors.eventBanner}
              accept="image/jpeg, image/png, image/webp, image/heic, image/heif, .heic, .heif"
            />
            <div className="col-span-3">
              <ImageUploadField
                label="Sponsor Logo(Recommended: 120x40)"
                multiple={true}
                onUpload={handleSponsorImagesChange}
                showRemove={true}
                accept="image/jpeg, image/png, image/webp, image/heic, image/heif, .heic, .heif"
              />
              <div className="mt-2 grid grid-cols-2 gap-4 md:grid-cols-4">
                {[...formData.sponsorImages].map((img, i) => {
                  const isExisting = typeof img === "string";

                  const src = isExisting
                    ? getImageUrl(img)
                    : URL.createObjectURL(img);

                  return (
                    <div key={i} className="relative rounded-[8px] border p-2">
                      <img
                        src={src}
                        alt={`Upload ${i + 1}`}
                        className="h-28 w-full object-contain"
                      />

                      <div className="mt-2 flex justify-end">
                        <button
                          type="button"
                          onClick={() => removeSponsorImage(i, isExisting)}
                          className="text-xs text-red-600 hover:text-red-800"
                        >
                          Remove
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </FormSection>
        <FormSection title="Date & Time">
          <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
            <InputField
              label="Event Start Date"
              name="eventStartDate"
              type="datetime-local"
              value={formData.eventStartDate}
              onChange={handleChange}
              error={errors.eventStartDate}
              required
            />

            <InputField
              label="Event End Date"
              name="eventEndDate"
              type="datetime-local"
              value={formData.eventEndDate}
              onChange={handleChange}
              error={errors.eventEndDate}
              required
            />
            <InputField
              label="Ticket Sales Start Date"
              name="ticketStartDate"
              type="datetime-local"
              value={formData.ticketStartDate}
              onChange={handleChange}
              error={errors.ticketStartDate}
              required
              isDisabled={!isTicketDatesEnabled}
              max={formData.eventStartDate || undefined}
            />

            <InputField
              label="Ticket Sales End Date"
              name="ticketEndDate"
              type="datetime-local"
              value={formData.ticketEndDate}
              onChange={handleChange}
              error={errors.ticketEndDate}
              required
              disabled={!isTicketDatesEnabled}
            />
            {formData.eventTimings.length > 0 && (
              <div className="col-span-2 space-y-4">
                <h4 className="text-sm font-semibold text-gray-800">
                  Event Timings
                </h4>
                {formData.eventTimings.map((timing, index) => (
                  <div
                    key={timing.date}
                    className="flex flex-wrap items-center gap-4"
                  >
                    <div className="min-w-[150px] flex-1">
                      <InputField
                        label={timing.day}
                        type="date"
                        value={timing.date?.split("T")[0] || ""}
                        disabled={true}
                      />
                    </div>

                    <div className="min-w-[150px] flex-1">
                      <InputField
                        label=" Start Time"
                        type="time"
                        value={timing.startTime}
                        onChange={(e) =>
                          handleTimingChange(index, "startTime", e.target.value)
                        }
                      />
                    </div>

                    <div className="min-w-[150px] flex-1">
                      <InputField
                        label="End Time"
                        type="time"
                        value={timing.endTime}
                        onChange={(e) =>
                          handleTimingChange(index, "endTime", e.target.value)
                        }
                      />
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </FormSection>
        <FormSection title="Venue & Location">
          <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
            <SelectField
              label="Country"
              name="companyCountry"
              value={formData.companyCountry}
              onChange={(e) =>
                setFormData((p) => ({
                  ...p,
                  companyCountry: e.target.value,
                  companyState: "",
                  companyCity: "",
                  companyDistrict: "",
                }))
              }
              options={countrySelectOptions}
              placeholder="Search country..."
              isSearchable={true}
              required
              error={errors.companyCountry}
            />
            <SelectField
              label="State"
              name="companyState"
              value={formData.companyState}
              onChange={(e) =>
                setFormData((p) => ({
                  ...p,
                  companyState: e.target.value,
                  companyCity: "",
                  companyDistrict: "",
                }))
              }
              options={stateSelectOptions}
              placeholder="Search state..."
              isSearchable={true}
              isDisabled={!formData.companyCountry}
              required
              error={errors.companyState}
            />
            <SelectField
              label="District"
              name="companyDistrict"
              value={formData.companyDistrict}
              onChange={(e) =>
                setFormData((p) => ({
                  ...p,
                  companyDistrict: e.target.value,
                  companyCity: e.target.value,
                }))
              }
              options={districtSelectOptions}
              placeholder="Search district..."
              isSearchable={true}
              isDisabled={!formData.companyState}
              error={errors.companyDistrict}
            />
            <InputField
              label="Zipcode"
              name="companyPincode"
              value={formData.companyPincode}
              onChange={handleChange}
              placeholder="Enter zipcode"
              error={errors.companyPincode}
            />
            <TextareaField
              label="Organizer Address"
              name="companyAddress"
              value={formData.companyAddress}
              onChange={handleChange}
              placeholder="Enter address details..."
              rows={3}
              error={errors.companyAddress}
            />
          </div>
        </FormSection>
        <FormSection title="Date & Time">
          <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
            <InputField
              label="Organizer Email"
              name="companyEmail"
              value={formData.companyEmail}
              onChange={handleChange}
              placeholder="Enter organizer email"
              required
              error={errors.companyEmail}
            />
            <PhoneNumberField
              label="Phone Number"
              name="companyMobile"
              codeName="companyMobileCountryCode"
              phoneValue={formData.companyMobile}
              codeValue={formData.companyMobileCountryCode}
              onChange={handleChange}
              onCodeChange={(val) => {
                setFormData((prev) => ({
                  ...prev,
                  companyMobileCountryCode: val,
                }));
                setErrors((p) => ({
                  ...p,
                  companyMobileCountryCode: "",
                }));
              }}
              options={countryCodeOptions}
              placeholder="712 345 678"
              required
              error={errors.companyMobile}
            />
            <InputField
              label="Website"
              name="companyWebsite"
              value={formData.companyWebsite}
              onChange={handleChange}
              placeholder="Enter website"
              error={errors.companyWebsite}
            />
            <InputField
              label="GST Number"
              name="companyGST"
              value={formData.companyGST}
              onChange={handleChange}
              placeholder="Enter GST number"
              error={errors.companyGST}
            />
          </div>
        </FormSection>
        <FormSection title="Admin Details">
          <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
            <InputField
              label="Admin Name"
              name="adminName"
              value={formData.adminName}
              onChange={handleChange}
              placeholder="Enter admin name"
              required
              error={errors.adminName}
            />

            <InputField
              label="Admin Email"
              name="adminEmail"
              value={formData.adminEmail}
              onChange={handleChange}
              placeholder="Enter admin email"
              required
              error={errors.adminEmail}
            />
            <PhoneNumberField
              label="Admin Mobile"
              name="adminMobile"
              codeName="adminMobileCountryCode"
              phoneValue={formData.adminMobile}
              codeValue={formData.adminMobileCountryCode}
              onChange={handleChange}
              onCodeChange={(val) => {
                setFormData((prev) => ({
                  ...prev,
                  adminMobileCountryCode: val,
                }));
                setErrors((p) => ({
                  ...p,
                  adminMobileCountryCode: "",
                }));
              }}
              options={countryCodeOptions}
              placeholder="712 345 678"
              required
              error={errors.adminMobile}
            />

            <InputField
              label="Password"
              name="adminPassword"
              value={formData.adminPassword}
              onChange={handleChange}
              placeholder="Enter Password"
              error={errors.adminPassword}
              required
              type="password"
            />
            <div className="col-span-2">
              <InputWithButtonField
                label="Communication Emails"
                name="emailInput"
                value={emailInput}
                onChange={(e) => setEmailInput(e.target.value)}
                placeholder="Enter email & press Add"
                onButtonClick={addEmail}
                buttonText="Add"
                required
              />

              <div className="col-span-2 mt-2 grid grid-cols-1 gap-2.5 md:grid-cols-2 lg:grid-cols-3">
                {formData.communicationEmails.map((email, i) => (
                  <div
                    key={i}
                    className="focus-within:border-slate-400 focus-within:ring-slate-400 flex items-center justify-between gap-2 rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 transition-colors focus-within:bg-white focus-within:ring-1"
                  >
                    <input
                      value={email}
                      onChange={(e) => updateEmail(i, e.target.value)}
                      className="bg-transparent text-slate-800 w-full text-xs font-medium outline-none placeholder:text-gray-400"
                    />

                    <button
                      type="button"
                      onClick={() => removeEmail(i)}
                      className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full text-gray-400 transition-colors hover:bg-red-100 hover:text-red-600"
                      title="Remove email"
                    >
                      <span className="text-sm font-bold leading-none">×</span>
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </FormSection>
        <FormSection title="Email Configuration">
          <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
            <SelectField
              label="Email Service Provider"
              name="emailProvider"
              value={formData.emailProvider}
              onChange={(e) =>
                setFormData((p) => ({
                  ...p,
                  emailProvider: e.target.value,
                }))
              }
              options={emailProviderOptions}
              placeholder="Select provider..."
              required
              error={errors.emailProvider}
            />

            {formData.emailProvider && (
              <>
                <InputField
                  label="Username (Email)"
                  name="emailUsername"
                  type="email"
                  value={formData.emailUsername}
                  onChange={handleChange}
                  placeholder="e.g. user@domain.com"
                  required
                  error={errors.emailUsername}
                />

                <InputField
                  label="App Password"
                  name="emailAppPassword"
                  type="password"
                  value={formData.emailAppPassword}
                  onChange={handleChange}
                  placeholder="Enter generated app password"
                  required
                  error={errors.emailAppPassword}
                />
              </>
            )}
          </div>
        </FormSection>
        <FormSection title="Social & App Store Links">
          <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
            <InputField
              label="Facebook Link"
              name="facebookLink"
              value={formData.facebookLink || ""}
              onChange={handleChange}
              placeholder="https://facebook.com/your-page"
              error={errors.facebookLink}
            />
            <InputField
              label="Instagram Link"
              name="instaLink"
              value={formData.instaLink || ""}
              onChange={handleChange}
              placeholder="https://instagram.com/your-profile"
              error={errors.instaLink}
            />
            <InputField
              label="LinkedIn Link"
              name="linkedinLink"
              value={formData.linkedinLink || ""}
              onChange={handleChange}
              placeholder="https://linkedin.com/company/your-company"
              error={errors.linkedinLink}
            />
            <InputField
              label="YouTube Link"
              name="youtubeLink"
              value={formData.youtubeLink || ""}
              onChange={handleChange}
              placeholder="https://youtube.com/@your-channel"
              error={errors.youtubeLink}
            />
            <InputField
              label="Google Play Store Link"
              name="playStoreLink"
              value={formData.playStoreLink || ""}
              onChange={handleChange}
              placeholder="https://play.google.com/store/apps/details?id=your.app"
              error={errors.playStoreLink}
            />
            <InputField
              label="Apple App Store Link"
              name="appStoreLink"
              value={formData.appStoreLink || ""}
              onChange={handleChange}
              placeholder="https://apps.apple.com/app/id123456789"
              error={errors.appStoreLink}
            />
          </div>
        </FormSection>
        <FormSection title="Legal & Policies">
          <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
            <InputField
              label="Terms & Conditions URL"
              name="termsAndConditions"
              value={formData.termsAndConditions}
              onChange={handleChange}
              placeholder="https://example.com/terms"
              required
              error={errors.termsAndConditions}
            />
            <InputField
              label="Privacy Policy URL"
              name="privacyPolicy"
              value={formData.privacyPolicy}
              onChange={handleChange}
              placeholder="https://example.com/privacy"
              required
              error={errors.privacyPolicy}
            />
          </div>
        </FormSection>
        {/* <FormSection title="Visitor App Features">
          <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
            {[
              "Exhibitor",
              "Event",
              "Article",
              "Offer",
              "Banner",
              "Map",
              "Net Work",
            ].map((m) => (
              <CheckboxField
                key={m}
                label={m}
                checked={formData.projectModules.includes(m)}
                onChange={() => handleModuleChange(m)}
              />
            ))}
            {errors.projectModules && (
              <p className="col-span-2 text-xs text-red-500">
                {errors.projectModules}
              </p>
            )}
          </div>
        </FormSection> */}
        <FormSection title="Pricing & Offers">
          <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
            <SelectField
              label="Currency"
              name="currency"
              value={formData.currency}
              onChange={(e) =>
                setFormData((p) => ({ ...p, currency: e.target.value }))
              }
              options={currencyOptions}
              placeholder="Select currency"
              error={errors.currency}
            />
            <InputField
              label="Ticket Price"
              name="price"
              type="number"
              value={formData.price}
              onChange={handleChange}
              placeholder="Enter price"
              error={errors.price}
            />

            <InputField
              label="Tax"
              name="tax"
              type="number"
              value={formData.tax}
              onChange={handleChange}
              placeholder="Enter tax"
              error={errors.tax}
            />
          </div>
          <div className="mt-2">
            <FormSection title="Date-Based Ticket Price Tiers">
              <div className=" space-y-3">
                {!isTicketDatesEnabled && (
                  <p className="text-xs font-medium text-amber-600">
                    Please set Event Start Date and Event End Date to configure
                    ticket price tiers.
                  </p>
                )}

                {formData.ticketPriceTiers.map((tier, index) => {
                  const tierError = errors.ticketPriceTiers?.[index] || {};

                  return (
                    <div key={index} className="flex flex-col gap-1">
                      <div className="flex flex-wrap items-start gap-3 ">
                        <div className="min-w-[140px] flex-1">
                          <InputField
                            label="Tier Title"
                            value={tier.title}
                            placeholder="e.g. Early Bird"
                            onChange={(e) =>
                              handlePriceTierChange(
                                index,
                                "title",
                                e.target.value
                              )
                            }
                            error={tierError.title}
                            isDisabled={!isTicketDatesEnabled}
                          />
                        </div>

                        <div className="min-w-[110px] flex-1">
                          <InputField
                            label="Price"
                            type="number"
                            value={tier.price}
                            placeholder="e.g. 50"
                            onChange={(e) =>
                              handlePriceTierChange(
                                index,
                                "price",
                                e.target.value
                              )
                            }
                            error={tierError.price}
                            isDisabled={!isTicketDatesEnabled}
                          />
                        </div>

                        <div className="min-w-[160px] flex-1">
                          <InputField
                            label="Start Date"
                            type="datetime-local"
                            value={tier.startDate}
                            onChange={(e) =>
                              handlePriceTierChange(
                                index,
                                "startDate",
                                e.target.value
                              )
                            }
                            error={tierError.startDate}
                            isDisabled={!isTicketDatesEnabled}
                            min={formData.ticketStartDate || undefined}
                            max={formData.ticketEndDate || undefined}
                          />
                        </div>

                        <div className="min-w-[160px] flex-1">
                          <InputField
                            label="End Date"
                            type="datetime-local"
                            value={tier.endDate}
                            onChange={(e) =>
                              handlePriceTierChange(
                                index,
                                "endDate",
                                e.target.value
                              )
                            }
                            error={tierError.endDate}
                            isDisabled={!isTicketDatesEnabled}
                            min={formData.ticketStartDate || undefined}
                            max={formData.ticketEndDate || undefined}
                          />
                        </div>

                        <button
                          type="button"
                          onClick={() => removePriceTier(index)}
                          className="mb-1 shrink-0 self-center p-2 font-bold text-red-500 hover:text-red-700"
                          title="Remove Tier"
                        >
                          ✕
                        </button>
                      </div>
                    </div>
                  );
                })}

                <div className="flex justify-end pt-1">
                  <button
                    type="button"
                    onClick={addPriceTier}
                    className="btn-primary text-sm"
                    disabled={!isTicketDatesEnabled}
                  >
                    + Add Price Tier
                  </button>
                </div>
              </div>
            </FormSection>
          </div>
          <div className="mt-2">
            <FormSection title="Ticket Quantity Discounts">
              <div className="col-span-2 space-y-3">
                {formData.ticketDiscounts.map((tier, index) => {
                  const tierError = errors.ticketDiscounts?.[index] || {};

                  return (
                    <div key={index} className="flex flex-col gap-1">
                      <div className="flex flex-wrap items-start gap-3 ">
                        <div className="min-w-[120px] flex-1">
                          <InputField
                            label="Min Quantity"
                            type="number"
                            value={tier.minQty}
                            placeholder="e.g. 1"
                            onChange={(e) =>
                              handleDiscountChange(
                                index,
                                "minQty",
                                e.target.value
                              )
                            }
                            error={tierError.minQty}
                          />
                        </div>

                        <div className="min-w-[120px] flex-1">
                          <InputField
                            label="Max Quantity"
                            type="number"
                            value={tier.maxQty}
                            placeholder="e.g. 2"
                            onChange={(e) =>
                              handleDiscountChange(
                                index,
                                "maxQty",
                                e.target.value
                              )
                            }
                            error={tierError.maxQty}
                          />
                        </div>

                        <div className="min-w-[120px] flex-1">
                          <InputField
                            label="Discount (%)"
                            type="number"
                            value={tier.discountPercentage}
                            placeholder="e.g. 15"
                            onChange={(e) =>
                              handleDiscountChange(
                                index,
                                "discountPercentage",
                                e.target.value
                              )
                            }
                            error={tierError.discountPercentage}
                          />
                        </div>

                        <button
                          type="button"
                          onClick={() => removeDiscountTier(index)}
                          className="mb-1 shrink-0 self-end p-2 font-bold text-red-500 hover:text-red-700"
                          title="Remove Tier"
                        >
                          ✕
                        </button>
                      </div>
                    </div>
                  );
                })}
                <div className="flex justify-end pt-1">
                  <button
                    type="button"
                    onClick={addDiscountTier}
                    className="btn-primary mt-2 text-sm"
                  >
                    + Add Discount Tier
                  </button>
                </div>
              </div>
            </FormSection>
          </div>
        </FormSection>
        <FormSection
          title={
            <div className="flex w-full items-center justify-between">
              <span>Supporting Business Operators (Event Features)</span>
              <button
                type="button"
                onClick={addEventFeature}
                className="btn-primary px-3 py-1.5 text-xs"
              >
                + Add Feature Card
              </button>
            </div>
          }
        >
          <div className="col-span-2 space-y-6">
            {formData.eventFeatures.length === 0 ? (
              <p className="text-xs italic text-gray-400">
                No feature cards added yet.
              </p>
            ) : (
              formData.eventFeatures.map((feature, index) => (
                <div
                  key={index}
                  className="space-y-4 rounded-xl border border-gray-200 bg-white p-5 shadow-sm"
                >
                  <div className="flex items-center justify-between border-b pb-3">
                    <h4 className="text-sm font-semibold text-gray-800">
                      Feature #{index + 1}
                    </h4>
                    <button
                      type="button"
                      onClick={() => removeEventFeature(index)}
                      className="text-xs font-semibold text-red-600 hover:text-red-800"
                    >
                      Remove Feature
                    </button>
                  </div>

                  <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
                    <ImageUploadField
                      label="Icon / Logo"
                      name={`feature_logo_${index}`}
                      preview={
                        feature.logo instanceof File
                          ? URL.createObjectURL(feature.logo)
                          : typeof feature.logo === "string" && feature.logo
                          ? getImageUrl(feature.logo)
                          : ""
                      }
                      onUpload={(e) =>
                        handleFeatureLogoChange(index, e.target.files?.[0])
                      }
                      error={errors[`eventFeatureLogo_${index}`]}
                      accept="image/jpeg, image/png, image/webp, image/heic, image/heif, .heic, .heif"
                    />

                    <InputField
                      label="Title"
                      value={feature.title}
                      onChange={(e) =>
                        handleFeatureChange(index, "title", e.target.value)
                      }
                      placeholder="e.g. CASE STUDIES"
                      required
                    />

                    <div className="md:col-span-2">
                      <TextareaField
                        label="Description"
                        value={feature.description}
                        onChange={(e) =>
                          handleFeatureChange(
                            index,
                            "description",
                            e.target.value
                          )
                        }
                        placeholder="Enter feature description..."
                        rows={3}
                        required
                      />
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </FormSection>

        <FormSection title="Hospitality Is Changing Section">
          <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
            <InputField
              label="Section Title"
              value={formData.hospitalitySection.title}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  hospitalitySection: {
                    ...prev.hospitalitySection,
                    title: e.target.value,
                  },
                }))
              }
              placeholder="e.g. HOSPITALITY IS CHANGING BEFORE OUR EYES..."
              required
            />

            <ImageUploadField
              label="Section Image"
              name="hospitalityImage"
              preview={
                formData.hospitalitySection.image instanceof File
                  ? URL.createObjectURL(formData.hospitalitySection.image)
                  : existingHospitalityImage
                  ? getImageUrl(existingHospitalityImage)
                  : ""
              }
              onUpload={async (e) => {
                const file = e.target.files?.[0];
                if (!file) return;

                // Validate file with size (e.g. 5 MB) and optional resolution options
                const { isValid, error } = await validateImageFile(file, 3);

                if (!isValid) {
                  setErrors((prev) => ({
                    ...prev,
                    hospitalityImage: error, // or whatever error key you use for this field
                  }));
                  return;
                }

                // File is valid: clear error and update state
                setErrors((prev) => ({
                  ...prev,
                  hospitalityImage: "",
                }));

                setFormData((prev) => ({
                  ...prev,
                  hospitalitySection: {
                    ...prev.hospitalitySection,
                    image: file,
                  },
                }));

                setExistingHospitalityImage(null);
              }}
              accept="image/jpeg, image/png, image/webp, image/heic, image/heif, .heic, .heif"
              error={errors.hospitalityImage}
            />

            <div className="md:col-span-2">
              <InputWithButtonField
                label="Add Bullet Points"
                value={formData.hospitalitySection.pointInput || ""}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    hospitalitySection: {
                      ...prev.hospitalitySection,
                      pointInput: e.target.value,
                    },
                  }))
                }
                placeholder="e.g. Costs are rising."
                onButtonClick={addHospitalityPoint}
                buttonText="Add Point"
              />

              <div className="mt-3 flex flex-col gap-2">
                {formData.hospitalitySection.points?.map((pt, idx) => (
                  <div
                    key={idx}
                    className="flex items-center justify-between rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-xs font-medium text-gray-700"
                  >
                    <span>• {pt}</span>
                    <button
                      type="button"
                      onClick={() => removeHospitalityPoint(idx)}
                      className="font-bold text-red-500 hover:text-red-700"
                    >
                      ✕
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </FormSection>

        {/* SECTION 2: WHY PARTICIPATE */}
        <FormSection
          title={
            <div className="flex w-full items-center justify-between">
              <span>Why Participate Section</span>
              <button
                type="button"
                onClick={addWhyColumn}
                className="btn-primary px-3 py-1.5 text-xs"
              >
                + Add Column
              </button>
            </div>
          }
        >
          <div className="col-span-2 space-y-6">
            <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
              <InputField
                label="Section Main Title"
                value={formData.whyParticipate.title}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    whyParticipate: {
                      ...prev.whyParticipate,
                      title: e.target.value,
                    },
                  }))
                }
                placeholder="e.g. WHY PARTICIPATE IN HORECA SUMMIT"
                required
              />

              <TextareaField
                label="Section Description"
                value={formData.whyParticipate.description}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    whyParticipate: {
                      ...prev.whyParticipate,
                      description: e.target.value,
                    },
                  }))
                }
                placeholder="Enter sub-header text..."
                rows={2}
              />
            </div>

            {/* Dynamic Columns */}
            {formData.whyParticipate.columns?.map((col, colIndex) => (
              <div
                key={colIndex}
                className="space-y-4 rounded-xl border border-gray-200 bg-white p-5 shadow-sm"
              >
                <div className="flex items-center justify-between border-b pb-3">
                  <h4 className="text-sm font-semibold text-gray-800">
                    Column #{colIndex + 1}
                  </h4>
                  <button
                    type="button"
                    onClick={() => removeWhyColumn(colIndex)}
                    className="text-xs font-semibold text-red-600 hover:text-red-800"
                  >
                    Remove Column
                  </button>
                </div>

                <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
                  <InputField
                    label="Column Title"
                    value={col.title}
                    onChange={(e) =>
                      handleWhyColumnChange(colIndex, "title", e.target.value)
                    }
                    placeholder="e.g. YOU WILL UNDERSTAND WHAT'S NEXT FOR:"
                    required
                  />

                  <InputField
                    label="Footer Note (Optional)"
                    value={col.footerText || ""}
                    onChange={(e) =>
                      handleWhyColumnChange(
                        colIndex,
                        "footerText",
                        e.target.value
                      )
                    }
                    placeholder="e.g. Or you simply make decisions..."
                  />

                  <div className="md:col-span-2">
                    <InputWithButtonField
                      label="Add Column Points"
                      value={col.pointInput || ""}
                      onChange={(e) =>
                        handleWhyColumnChange(
                          colIndex,
                          "pointInput",
                          e.target.value
                        )
                      }
                      placeholder="Enter point & press Add"
                      onButtonClick={() => addPointToWhyColumn(colIndex)}
                      buttonText="Add Point"
                    />

                    <div className="mt-3 flex flex-col gap-2">
                      {col.points?.map((pt, pIdx) => (
                        <div
                          key={pIdx}
                          className="flex items-center justify-between rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-xs font-medium text-gray-700"
                        >
                          <span>✓ {pt}</span>
                          <button
                            type="button"
                            onClick={() =>
                              removePointFromWhyColumn(colIndex, pIdx)
                            }
                            className="font-bold text-red-500 hover:text-red-700"
                          >
                            ✕
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}

            {/* Bottom Callout Banner */}
            <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
              <TextareaField
                label="Participate Bottom Card Text"
                value={formData.whyParticipate.bottomBannerText || ""}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    whyParticipate: {
                      ...prev.whyParticipate,
                      bottomBannerText: e.target.value,
                    },
                  }))
                }
                placeholder="e.g. Participate in the Horeca Summit! An exclusive opportunity..."
                rows={2}
              />

              <InputField
                label="Bottom Button Text"
                value={
                  formData.whyParticipate.bottomButtonText || "GET YOUR TICKET"
                }
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    whyParticipate: {
                      ...prev.whyParticipate,
                      bottomButtonText: e.target.value,
                    },
                  }))
                }
                placeholder="GET YOUR TICKET"
              />
            </div>
          </div>
        </FormSection>

        {/* <Section title="Organizer Details">
          <SelectField
            label="Organizer Mobile Country Code"
            name="companyMobileCountryCode"
            value={formData.companyMobileCountryCode}
            onChange={(e) =>
              setFormData((p) => ({
                ...p,
                companyMobileCountryCode: e.target.value,
              }))
            }
            options={countryCodeOptions}
            placeholder="Search country code..."
            isSearchable={true}
            required
            error={errors.companyMobileCountryCode}
          />
          <InputField
            label="Organizer Mobile"
            name="companyMobile"
            value={formData.companyMobile}
            onChange={handleChange}
            placeholder="Enter organizer mobile"
            error={errors.companyMobile}
            required
            type="tel"
          />
          <InputField
            label="Phone Number"
            name="companyPhoneNumber"
            value={formData.companyPhoneNumber}
            onChange={handleChange}
            placeholder="Enter phone number"
            error={errors.companyPhoneNumber}
          />

          <InputField
            label="City"
            name="companyCity"
            value={formData.companyCity}
            onChange={handleChange}
            placeholder="Enter city"
            error={errors.companyCity}
          />
        </Section> */}
        {/* PRICING & TICKET SCHEDULE (ADDED TO MATCH SCHEMA) */}
        {/* <Section title="Pricing & Event Schedule"></Section> */}

        {/* ADMIN DETAILS */}
        {/* <Section title="Admin Details">
          <SelectField
            label="Admin Mobile Country Code"
            name="adminMobileCountryCode"
            value={formData.adminMobileCountryCode}
            onChange={(e) =>
              setFormData((p) => ({
                ...p,
                adminMobileCountryCode: e.target.value,
              }))
            }
            options={countryCodeOptions}
            placeholder="Search country code..."
            isSearchable={true}
            required
            error={errors.adminMobileCountryCode}
          />

          <InputField
            label="Admin Mobile"
            name="adminMobile"
            value={formData.adminMobile}
            onChange={handleChange}
            placeholder="Enter admin mobile"
            error={errors.adminMobile}
            required
            type="tel"
          />
        </Section> */}
        {/* PROJECT MODULES & BULK CONFIGURATION */}
        {/* <Section title="Project Modules & Config">
          {[
            "Exhibitor",
            "Event",
            "Article",
            "Offer",
            "Banner",
            "Map",
            "Net Work",
          ].map((m) => (
            <CheckboxField
              key={m}
              label={m}
              checked={formData.projectModules.includes(m)}
              onChange={() => handleModuleChange(m)}
            />
          ))}


          {errors.projectModules && (
            <p className="col-span-2 text-xs text-red-500">
              {errors.projectModules}
            </p>
          )}
        </Section> */}
        {/* TICKET PRICE TIERS SECTION (DATE-BASED) */}
        {/* <Section title="Date-Based Ticket Price Tiers"></Section> */}
        {/* TICKET DISCOUNT TIERS SECTION */}
        {/* <Section title="Ticket Quantity Discounts"></Section> */}
        {/* EMAIL CONFIGURATION SECTION */}
        {/* <Section title="Email Configuration"></Section> */}
        {/* SOCIAL MEDIA & APP STORE LINKS */}
        {/* <Section title="Social & App Store Links"></Section>
        <Section title="Legal & Policies"></Section>
        <Section title="Sponsor Logos">
          <div className="col-span-2 space-y-3"></div>
        </Section> */}
        {/* COMMUNICATION EMAILS */}

        {/* DYNAMIC STAFF DETAILS SECTION */}
        {/* <FormSection
          title={
            <div className="flex w-full items-center justify-between">
              <span>Staff Details</span>
              <button
                type="button"
                onClick={addStaff}
                className="btn-primary px-3 py-1.5 text-xs"
              >
                + Add Staff
              </button>
            </div>
          }
        >
          <div className="col-span-2 space-y-6">
            {formData.staffDetails.map((staff, staffIndex) => (
              <div
                key={staffIndex}
                className="space-y-4 rounded-xl border border-gray-200 bg-white p-5 shadow-sm"
              >
                <div className="flex items-center justify-between border-b pb-3">
                  <h4 className="text-sm font-semibold text-gray-800">
                    Staff #{staffIndex + 1}
                  </h4>

                  <button
                    type="button"
                    onClick={() => removeStaff(staffIndex)}
                    className="text-xs font-semibold text-red-600 hover:text-red-800"
                  >
                    Remove Staff
                  </button>
                </div>

                <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
                  <InputField
                    label={`Staff ${staffIndex + 1} Email`}
                    name={`staff_email_${staffIndex}`}
                    value={staff.email || ""}
                    onChange={(e) =>
                      handleStaffChange(staffIndex, "email", e.target.value)
                    }
                    placeholder="Enter staff email"
                    error={errors[`staff_email_${staffIndex}`]}
                  />
                  <InputField
                    label={`Staff ${staffIndex + 1} Password`}
                    name={`staff_password_${staffIndex}`}
                    value={staff.password || ""}
                    onChange={(e) =>
                      handleStaffChange(staffIndex, "password", e.target.value)
                    }
                    placeholder="Enter password"
                    type="password"
                    error={errors[`staff_password_${staffIndex}`]}
                  />
                </div>

                <div className="overflow-x-auto">
                  <table className="min-w-full rounded-lg border border-gray-200 text-sm">
                    <thead className="bg-gray-100">
                      <tr>
                        <th className="px-4 py-2.5 text-left font-medium text-gray-700">
                          Route
                        </th>
                        <th className="px-4 py-2.5 text-center font-medium text-gray-700">
                          Read
                        </th>
                        <th className="px-4 py-2.5 text-center font-medium text-gray-700">
                          Create
                        </th>
                        <th className="px-4 py-2.5 text-center font-medium text-gray-700">
                          Update
                        </th>
                        <th className="px-4 py-2.5 text-center font-medium text-gray-700">
                          Delete
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {staff.permissions?.map((route, routeIndex) => (
                        <tr
                          key={route.key || routeIndex}
                          className="border-t border-gray-100"
                        >
                          <td className="px-4 py-2 text-gray-800">
                            {route.key}
                          </td>
                          <td className="text-center">
                            <input
                              type="checkbox"
                              checked={route.can_read || false}
                              onChange={() =>
                                handlePermissionChange(
                                  staffIndex,
                                  routeIndex,
                                  "can_read"
                                )
                              }
                            />
                          </td>
                          <td className="text-center">
                            <input
                              type="checkbox"
                              checked={route.can_create || false}
                              onChange={() =>
                                handlePermissionChange(
                                  staffIndex,
                                  routeIndex,
                                  "can_create"
                                )
                              }
                            />
                          </td>
                          <td className="text-center">
                            <input
                              type="checkbox"
                              checked={route.can_update || false}
                              onChange={() =>
                                handlePermissionChange(
                                  staffIndex,
                                  routeIndex,
                                  "can_update"
                                )
                              }
                            />
                          </td>
                          <td className="text-center">
                            <input
                              type="checkbox"
                              checked={route.can_delete || false}
                              onChange={() =>
                                handlePermissionChange(
                                  staffIndex,
                                  routeIndex,
                                  "can_delete"
                                )
                              }
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ))}
          </div>
        </FormSection> */}
        {/* SUBMIT BUTTONS */}
        {/* <div className="button-div mt-6 flex justify-between">
          {onBack && (
            <button type="button" onClick={onBack} className="btn-cancel">
              Back
            </button>
          )}
          <button type="submit" className="btn-primary flex items-center gap-2">
            <span>{submitLabel}</span>
            <FiArrowRight size={16} />
          </button>
        </div> */}
      </form>
    </PageLayout>
  );
}
